export default {
    "name": "CreateVehicleAttachment",
    "kind": "HoudiniMutation",
    "hash": "842ea1397f5f3aba9800b80607e66de78d98a5e2890044c4459dba479457f929",

    "raw": `mutation CreateVehicleAttachment($input: NewVehicleAttachment!) {
  createVehicleAttachment(input: $input) {
    fileId: id
    rank
    public
    file {
      id
      name
      path: url
      type
      size
      mimeType: mimetype
      extension
      updated
      createdDate: created
    }
    id
  }
}
`,

    "rootType": "Mutation",
    "stripVariables": [],

    "selection": {
        "fields": {
            "createVehicleAttachment": {
                "type": "VehicleAttachment",
                "keyRaw": "createVehicleAttachment(input: $input)",

                "selection": {
                    "fields": {
                        "fileId": {
                            "type": "UInt",
                            "keyRaw": "fileId",
                            "visible": true
                        },

                        "rank": {
                            "type": "Int",
                            "keyRaw": "rank",
                            "visible": true
                        },

                        "public": {
                            "type": "Boolean",
                            "keyRaw": "public",
                            "visible": true
                        },

                        "file": {
                            "type": "File",
                            "keyRaw": "file",

                            "selection": {
                                "fields": {
                                    "id": {
                                        "type": "Int",
                                        "keyRaw": "id",
                                        "visible": true
                                    },

                                    "name": {
                                        "type": "String",
                                        "keyRaw": "name",
                                        "visible": true
                                    },

                                    "path": {
                                        "type": "String",
                                        "keyRaw": "path",
                                        "visible": true
                                    },

                                    "type": {
                                        "type": "FileType",
                                        "keyRaw": "type",
                                        "visible": true
                                    },

                                    "size": {
                                        "type": "Int",
                                        "keyRaw": "size",
                                        "visible": true
                                    },

                                    "mimeType": {
                                        "type": "String",
                                        "keyRaw": "mimeType",
                                        "visible": true
                                    },

                                    "extension": {
                                        "type": "String",
                                        "keyRaw": "extension",
                                        "visible": true
                                    },

                                    "updated": {
                                        "type": "Date",
                                        "keyRaw": "updated",
                                        "visible": true
                                    },

                                    "createdDate": {
                                        "type": "DateTime",
                                        "keyRaw": "createdDate",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "input": "NewVehicleAttachment"
        },

        "types": {
            "NewVehicleAttachment": {
                "file": "Upload",
                "public": "Boolean",
                "rank": "Int",
                "vehicleId": "UInt"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    }
};

"HoudiniHash=2af95586504b522e1c132c25198f75d208e0b3940810b34364fc5e1ba1b999bd";